import React, { useEffect, useState } from 'react'
import { NotFound } from 'components/NotFound'
import FinbrokerService from 'lib/api/services/finbroker.service'
import CreditRequestsCard from '../../Mobile/WorkListView/CreditRequestCard'
import { useResErrors } from '../../../hooks'
import { useHomeStoreRop } from '../../../context/HomeStore/Rop'

export const WorkListCreditRequests = ({ globalId }) => {
  const [credits, setCredits] = useState(null)
  const { standardCheck } = useResErrors()
  const {
    homeStore: { branches }
  } = useHomeStoreRop()
  useEffect(() => {
    if (globalId) {
      FinbrokerService.getCreditRequests(globalId).then(res =>
        standardCheck(res, async res => {
          if (res.data.length > 0) {
            const data = res.data.map(item => {
              const keys = {
                approvedByMogo: 'Mogo',
                approvedByKmf: 'Kmf',
                approvedByRangeld: 'Rangeld',
                approvedByShinhan: 'Shinhan',
                approvedByBcc: 'Bcc',
                approvedByKaspi: 'Kaspi',
                approvedByMycar: 'Mycar',
                approvedByHalyk: 'Halyk',
                approvedByBereke: 'Bereke',
                approvedByTfs: 'Tfs',
                approvedByFreedom: 'Freedom',
                approvedByEurasianBank: 'EurasianBank',
                approvedByForte: 'Forte'
              }
              const keysAlternative = {
                bccIsAlternative: 'Bcc',
                berekeIsAlternative: 'Bereke',
                eurasianIsAlternative: 'EurasianBank',
                forteIsAlternative: 'Forte',
                freedomIsAlternative: 'Freedom',
                halykIsAlternative: 'Halyk',
                kaspiIsAlternative: 'Kaspi',
                kmfIsAlternative: 'Kmf',
                mogoIsAlternative: 'Mogo',
                mycarIsAlternative: 'Mycar',
                rangeldIsAlternative: 'Rangeld',
                sapaIsAlternative: 'Sapa',
                shinhanIsAlternative: 'Shinhan',
                tfsIsAlternative: 'Tfs'
              }
              const banksAlternative = Object.keys(keysAlternative)
                .filter(
                  key => item?.hasOwnProperty(key) && item?.[key] === true
                )
                .map(value => {
                  const decisionDescriptionKey = `${value.replace(
                    'IsAlternative',
                    'DecisionDescription'
                  )}`
                  return {
                    name: keysAlternative[value],
                    decisionDescription: item?.[decisionDescriptionKey]
                  }
                })

              const banks = Object.keys(keys)
                .filter(key => typeof item?.[key] === 'boolean')
                .map(value => {
                  const bankInfo = {
                    name: keys[value],
                    approved: item?.[value],
                    date: item?.createdAt,
                    creditAmount: item?.creditAmount,
                    downPaymentAmount: item?.downPaymentAmount,
                    creditTerm: item?.creditTerm,
                    saleGlobalId: item?.saleGlobalId,
                    vin: item?.carVinCode,
                    manager: item?.createdByFullName,
                    branch: branches?.find(br => br.code === item?.branchCode)
                      ?.name
                  }

                  const alternativeInfo = banksAlternative.find(
                    alt => alt?.name === bankInfo?.name
                  )
                  if (!!alternativeInfo) {
                    bankInfo.decisionDescription =
                      alternativeInfo?.decisionDescription
                    bankInfo.alternative = true
                  }

                  return bankInfo
                })

              return {
                clientFirstname: item.clientFirstname,
                clientLastname: item.clientLastname,
                clientPatronymic: item.clientPatronymic,
                clientIIN: item.clientIIN,
                banks: banks
              }
            })
            return setCredits(data || [])
          }
          setCredits(res.data || [])
        })
      )
    }
  }, [globalId])

  return (
    <div
      style={{
        padding: 16,
        dispplay: 'flex',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      {credits?.length ? (
        credits?.map((item, index) => (
          <CreditRequestsCard creditRequest={item} key={index} />
        ))
      ) : (
        <NotFound title="Нет кредитных заявок" />
      )}
    </div>
  )
}
